<template>
	<div>
		<span
			v-if="
				currentMeeting?.status !== 'errored' &&
				currentMeeting?.status !== 'processed'
			"
			class="text-gray-500"
		>
			Samenvatting wordt gemaakt...
		</span>
		<AppButton
			v-else-if="currentMeeting?.status === 'processed'"
			@click="downloadWord"
		>
			<img
				src="/logos/word_ico.svg"
				class="w-4 h-4"
				alt=""
				aria-hidden="true"
			/>
			Opslaan als .docx
		</AppButton>
		<!-- eslint-disable-next-line vue/no-v-html -->
		<div class="markdown" v-html="sanitzedHtml"></div>
	</div>
</template>

<script setup lang="ts">
import { marked } from "marked";
import DOMPurify from "dompurify";
import { asyncComputed } from "@vueuse/core";
import { formatTimestamp } from "@/helpers/uiHelpers";
import { inject } from "vue";
import { conversationKey } from "@/keys";
import { saveAs } from "file-saver";
import { getTitle } from "@/helpers/conversationHelpers";

DOMPurify.removeAllHooks();
DOMPurify.addHook("uponSanitizeElement", (node, data) => {
	if (data.tagName === "time-stamp" && node.textContent) {
		const time = document.createElement("a");
		time.textContent = `(${formatTimestamp(Number(node.textContent))})`;
		time.setAttribute("data-seconds", node.textContent);
		node.parentNode?.replaceChild(time, node);
	}
});

const currentMeeting = inject(conversationKey);

const sanitzedHtml = asyncComputed(async () => {
	const summary = currentMeeting?.value?.summary;
	if (!summary) {
		return "";
	}

	const markdown = await marked.parse(summary);

	const res = DOMPurify.sanitize(markdown, {
		CUSTOM_ELEMENT_HANDLING: {
			tagNameCheck: (t) => {
				return t === "time-stamp";
			},
		},
	});

	return res;
}, "");

async function downloadWord() {
	if (!currentMeeting?.value) {
		return;
	}

	const meeting = currentMeeting.value;

	const { markdownDocx, Packer } = await import("markdown-docx");
	const doc = await markdownDocx(meeting.summary ?? "");

	await Packer.toBlob(doc).then((blob) => {
		const title = getTitle(meeting);
		saveAs(blob, `${title}.docx`);
	});
}
</script>
